import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import { protectSheetWithRandomPassword } from "./ExcelUtils";

export const exportNonPriorityCustomerAccountsExcel = async ({ data = [], productName = "", loginPlaceId }) => {
    try {
        if (!Array.isArray(data)) throw new Error("Invalid data format");

        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Non-Priority Customer Accounts");

        sheet.columns = [
            { key: "accNumber",     width: 24, alignment: { vertical: "middle", horizontal: "left" } },
            { key: "customerNo",    width: 50, alignment: { vertical: "top", horizontal: "left", wrapText: true } },
            { key: "productName",   width: 36, alignment: { vertical: "middle", horizontal: "left" } },
            { key: "createdDate",   width: 20, alignment: { vertical: "middle", horizontal: "center" } },
            { key: "amount",        width: 22, alignment: { vertical: "middle", horizontal: "right" }, numFmt: "#,##0.00" },
            { key: "createdByUser", width: 85, alignment: { vertical: "middle", horizontal: "left" } },
            { key: "branchName",    width: 28, alignment: { vertical: "middle", horizontal: "left" } },
        ];

        sheet.mergeCells("A1:G1");
        const titleCell = sheet.getCell("A1");
        titleCell.value = "NON-PRIORITY CUSTOMER ACCOUNTS";
        titleCell.font  = { bold: true, size: 14, color: { argb: "FF1F3A5F" } };
        titleCell.alignment = { horizontal: "center", vertical: "middle" };
        sheet.getRow(1).height = 28;

        sheet.mergeCells("A2:G2");
        const productCell = sheet.getCell("A2");
        productCell.value = productName
            ? `Product: ${productName}`
            : "Non-Priority Customer Accounts Report";
        productCell.font  = { bold: true, size: 11, color: { argb: "FF444444" } };
        productCell.alignment = { horizontal: "center" };
        sheet.getRow(2).height = 20;

        sheet.mergeCells("A3:G3");
        const metaCell = sheet.getCell("A3");
        metaCell.value = `Generated: ${dayjs().format("YYYY-MM-DD HH:mm:ss")}`;
        metaCell.font  = { italic: true, size: 9, color: { argb: "FF666666" } };
        metaCell.alignment = { horizontal: "center" };
        sheet.getRow(3).height = 16;

        sheet.addRow([]);

        const headerRow = sheet.addRow([
            "Account Number",
            "Customer Number",
            "Product Name",
            "Created Date",
            "Amount (Rs.)",
            "Created By User",
            "Branch",
        ]);
        headerRow.height = 22;
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 10 };
            cell.fill = {
                type:    "pattern",
                pattern: "solid",
                fgColor: { argb: "FF2B4C7E" },
            };
            cell.alignment = { horizontal: "center", vertical: "middle" };
            cell.border = {
                top:    { style: "thin", color: { argb: "FFCCCCCC" } },
                left:   { style: "thin", color: { argb: "FFCCCCCC" } },
                bottom: { style: "thin", color: { argb: "FFCCCCCC" } },
                right:  { style: "thin", color: { argb: "FFCCCCCC" } },
            };
        });

        if (data.length === 0) {
            sheet.mergeCells("A6:G6");
            const emptyCell = sheet.getCell("A6");
            emptyCell.value = "No records found for the selected savings product.";
            emptyCell.font  = { italic: true, color: { argb: "FF888888" } };
            emptyCell.alignment = { horizontal: "center" };
        } else {
            let totalAmount = 0;

            const rows = new Array(data.length);
            for (let i = 0; i < data.length; i++) {
                const row = data[i];
                const amt = row.amount != null ? Number(row.amount) : 0;
                totalAmount += amt;

                rows[i] = [
                    row.accNumber     || "",
                    row.customerNo    || "",
                    row.productName   || "",
                    row.createdDate   ? dayjs(row.createdDate).format("YYYY-MM-DD") : "",
                    amt,
                    row.createdByUser || "",
                    row.branchName    || "",
                ];
            }

            sheet.addRows(rows);

            const firstDataRow = 6;
            for (let i = 0; i < rows.length; i++) {
                const customerCell = sheet.getCell(firstDataRow + i, 2);
                customerCell.alignment = { vertical: "top", horizontal: "left", wrapText: true };
            }

            const totalRow = sheet.addRow([
                `Total Accounts: ${data.length}`,
                "",
                "",
                "",
                totalAmount,
                "",
                "",
            ]);
            totalRow.getCell(1).font = { bold: true };
            totalRow.getCell(5).font = { bold: true };
            totalRow.getCell(5).numFmt = "#,##0.00";
            totalRow.getCell(5).alignment = { horizontal: "right", vertical: "middle" };
            totalRow.eachCell((cell) => {
                cell.fill = {
                    type:    "pattern",
                    pattern: "solid",
                    fgColor: { argb: "FFD0D9E8" },
                };
            });
        }

        sheet.views = [{ state: "frozen", ySplit: 5 }];

        sheet.autoFilter = { from: { row: 5, column: 1 }, to: { row: 5, column: 7 } };

        if (loginPlaceId === "1") {
            await protectSheetWithRandomPassword(sheet, 12);
        }

        const fileName = `Non_Priority_Customer_Accounts_Report_${dayjs().format("YYYYMMDD_HHmmss")}.xlsx`;
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, fileName);
    } catch (err) {
        console.error("exportNonPriorityCustomerAccountsExcel error:", err);
        throw err;
    }
};
